import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Container,
  Grid,
  Radio,
  Typography,
} from '@mui/joy'
import Avatar from '@mui/joy/Avatar'
import WallpaperIcon from '@mui/icons-material/Wallpaper'
import ListItemContent from '@mui/joy/ListItemContent'
import ColorPicker from '../../ColorPicker'
import FileUpload from '../../FileUpload'
import React, { useState } from 'react'
import {
  useUpdateStoreMutation,
  useUploadBackgroundImageMutation,
} from '../../../services/branding'

enum CardBgMode {
  COLOR,
  IMAGE,
}

function BackGroundSettings() {
  const [selectedCardBgMode, setSelectedCardBgMode] = useState(CardBgMode.COLOR)

  const [backGroundColor, setBackGroundColor] = useState<string>()

  const [backgroundImageUrl, setBackgroundImageUrl] = useState('')

  const [, { isLoading: isUploadBackgroundImageLoading }] =
    useUploadBackgroundImageMutation({ fixedCacheKey: 'shared-delete-reward' })

  const [updateStore] = useUpdateStoreMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  const handleUploadSuccess = () => {
    setBackGroundColor('')
    updateStore({
      backgroundColor: '',
      backgroundImageUrl:
        'https://pub-52a881a119c44623a11fc78a00d89abb.r2.dev/uploads/1793c8fa-b65f-469e-8e13-8c5554459250',
    })
  }

  const handleUploadError = (error: unknown) => {
    console.error('Upload failed', error)
  }

  const handleColorPicked = (result: string | undefined) => {
    updateStore({ backgroundColor: result, backgroundImageUrl: '' })
    setBackgroundImageUrl('')
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.value) {
      case 'color':
        setSelectedCardBgMode(CardBgMode.COLOR)
        break
      case 'image':
        setSelectedCardBgMode(CardBgMode.IMAGE)
        break
    }
  }

  return (
    <Accordion>
      <AccordionSummary>
        <Avatar color="primary">
          <WallpaperIcon />
        </Avatar>
        <ListItemContent>
          <Typography level="title-md">Kártya háttér</Typography>
          <Typography level="body-sm">
            Kártya hattérszín beállítás vagy háttérkép feltöltés
          </Typography>
        </ListItemContent>
      </AccordionSummary>
      <AccordionDetails>
        <Container maxWidth="xs" sx={{ pt: 2, pb: 2 }}>
          <Container maxWidth="xs" sx={{ pt: 2, pb: 2 }}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <Grid>
                <Radio
                  checked={selectedCardBgMode === CardBgMode.COLOR}
                  onChange={handleChange}
                  value="color"
                  label="Háttérszín"
                />
              </Grid>
              <Grid sx={{ pl: 2 }}>
                <Radio
                  checked={selectedCardBgMode === CardBgMode.IMAGE}
                  onChange={handleChange}
                  value="image"
                  label="Kép"
                />
              </Grid>
            </Grid>
          </Container>

          {selectedCardBgMode === CardBgMode.COLOR && (
            <Card sx={{ mt: 2 }}>
              <label style={{ paddingLeft: 12 }}>Háttérszín</label>
              <Grid
                container
                direction="column"
                alignItems="center"
                spacing={-3}
              >
                <ColorPicker
                  pickedColor={backGroundColor}
                  setPickedColor={setBackGroundColor}
                  changeCompleted={handleColorPicked}
                />
              </Grid>
            </Card>
          )}

          {selectedCardBgMode === CardBgMode.IMAGE && (
            <Grid container alignItems="center" justifyContent="center">
              <FileUpload
                backgroundImageUrl={backgroundImageUrl}
                setBackgroundImageUrl={setBackgroundImageUrl}
                onUploadError={handleUploadError}
                onUploadSuccess={handleUploadSuccess}
                isUploadBackgroundImageLoading={isUploadBackgroundImageLoading}
              />
            </Grid>
          )}
        </Container>
      </AccordionDetails>
    </Accordion>
  )
}

export default BackGroundSettings
